/**
 * Money utillity functions
 */
export const money = {
  toCents(value) {
    if (value === null || value === undefined || value === "") return 0

    const num = Number(value)

    if (Number.isNaN(num)) {
      throw new Error("Invalid money value")
    }

    return Math.round(num * 100)
  },

  fromCents(cents) {
    if (cents === null || cents === undefined) return "0.00"

    return (cents / 100).toFixed(2)
  },
}
